import { FlaskConical } from 'lucide-react'
import { defineModule } from '@/shell/module-system'
import { SampleRequestsPage } from './pages/SampleRequestsPage'
import { SampleRequestDetailPage } from './pages/SampleRequestDetailPage'

/**
 * Uviva Sample Requests (2026-06-17).
 *
 * Command & control for Uviva product sample requests. SPI distributes
 * material on behalf of Uviva; reps and team members request samples here
 * (one form, one board) and track them from request through delivery and
 * follow-up. The delivery happens in Odoo; a reconciler links each card to
 * the Odoo delivery and syncs tracking. A 2-business-day ship SLA flags
 * overdue requests and a daily nudge emails owners + Ella/Angie/Emma/Chris.
 *
 * Form-driven, Uviva-scoped v1 — no email-inbox ingestion.
 * Permissions: admin / sales / operations + inside & outside sales reps, plus
 * the external `uviva` vendor role (read the full board + create a request
 * only — all other writes stay editor-only; see utils/permissions.ts).
 */
export default defineModule({
  id: 'sample-requests',
  name: 'Uviva Samples',
  shortName: 'Samples',
  icon: FlaskConical,
  navSection: 'vendors',
  navOrder: 40,
  urlNamespace: '/sample-requests',
  routes: [
    { path: '/', element: SampleRequestsPage, label: 'Uviva Samples' },
    {
      path: '/$requestId',
      element: SampleRequestDetailPage,
      label: 'Sample request detail',
    },
  ],
  permissions: [
    'admin',
    'sales',
    'operations', 'operations_logistics', 'purchasing',
    'outside_sales_rep',
    'inside_sales_rep',
    'uviva',
  ],
  densityDefault: 'comfortable',
  mobileStrategy: 'desktop-only',

  keyboardShortcut: 'g s r',

  commandPaletteEntries: [
    {
      label: 'Go to Uviva Samples',
      keywords: [
        'sample',
        'samples',
        'uviva',
        'request',
        'specimen',
        'tracking',
        'follow up',
      ],
      path: '/',
      group: 'modules',
      shortcut: 'g s r',
    },
    {
      label: 'New Uviva sample request',
      keywords: ['new', 'sample', 'request', 'uviva', 'create'],
      path: '/',
      group: 'actions',
    },
  ],
})
